/**
 * The backend's vendors/shop list endpoint has no 'trending'/'recommended'/'popular'
 * signal (only is_featured, distance, rating, shop_type). These flags gate UI that's
 * built and ready, but shows client-side heuristics rather than a real backend signal -
 * flip to true once the backend exposes the real data.
 */
export const FEATURE_FLAGS = {
  trendingShops: false,
  recommendedShops: false,
  popularBadge: false,
} as const;
